import React from "react";

interface WizardSectionProps {
    number: number;
    title: string;
    description: string | null;
    children: React.ReactNode;
}

export const WizardSection: React.FC<WizardSectionProps> = props => {
    const { number, title, description, children } = props;

    return (
        <div className="rounded-lg border border-gray-200 bg-gray-50/60 p-4 space-y-4">
            <div>
                <div className="flex items-center gap-2">
                    <span className="grid place-items-center w-6 h-6 shrink-0 rounded-full bg-brand-600 text-white text-xs font-bold">
                        {number}
                    </span>
                    <span className="text-sm font-medium text-gray-700">{title}</span>
                </div>
                {description ? (
                    <p className="mt-1 ml-8 text-sm text-gray-500">{description}</p>
                ) : null}
            </div>
            {children}
        </div>
    );
};
